if (!customElements.get('nurkil-header-search')) {
  customElements.define('nurkil-header-search', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const details = this.querySelector('details');
      const trigger = this.querySelector('summary');
      const input = this.querySelector('input[type="search"]');
      const closeButton = this.querySelector('[data-search-close]');
      const menu = this.closest('header').querySelector('.nurkil-mobile-menu');
      const close = (restoreFocus = false) => {
        details.open = false;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      closeButton.hidden = false;
      trigger.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          if (menu) menu.open = false;
          input.focus({ preventScroll: true });
        }
      }, options);
      closeButton.addEventListener('click', () => close(true), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close(true);
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (details.open && !this.contains(event.target)) close();
      }, options);
      document.addEventListener('focusin', (event) => {
        if (details.open && !this.contains(event.target)) close();
      }, options);
      menu?.addEventListener('toggle', () => {
        if (menu.open) close();
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
